import { CartTypes } from '../constants/cart.types';
import { ActionModel } from '../../typeDef/redux.model';

export const setItemCount = (count: number): ActionModel => {
    return {
        type: CartTypes.SET_ITEM_COUNT,
        payload: count
    }
}